@if (isPopupVisible) {
  <div class="modal-backdrop"></div>
}

<p-toast
  [position]="position"
  [key]="key"
  (onClose)="rejectionHandler($event.message.summary ?? 'NA')"
  [baseZIndex]="5000"
>
  <ng-template let-message pTemplate="message">
    <div
      class="flex flex-column align-items-start {{ styleClassName }}"
      [ngStyle]="
        message.severity === 'success' ? { 'padding-left': '16px' } : {}
      "
      style="flex: 1"
    >
      @if (message.severity !== "success") {
        <i
          style="top: 1px"
          [ngStyle]="message.severity === 'info' ? { color: '#0a1a29' } : {}"
          class="{{ getIconClass(message.summary, message.severity) }}"
        ></i>
        <h4
          [ngStyle]="message.severity === 'info' ? { color: '#0a1a29' } : {}"
          style="margin: 0"
        >
          {{ message.summary }}
        </h4>
      }
      <div class="confirmation-box">
        @if (message.detail?.successMessage || message.detail?.errorMessage) {
          <div class="confirmation-box-subitem">
            @if (message.detail.successMessage?.length > 0) {
              <span
                class="pi pi-check"
                style="
                  color: #22c55e;
                  padding-top: 2px;
                  display: flex;
                  word-break: break-word;
                  flex-wrap: wrap;
                "
              ></span>
            }
            <div>
              @for (mssgs of message.detail?.successMessage; track $index) {
                <p
                  style="
                    margin: 1px;
                    color: #22c55e;
                    display: flex;
                    word-break: break-word;
                    flex-wrap: wrap;
                  "
                  [ngStyle]="{
                    'margin-bottom':
                      $index === message.detail.successMessage.length - 1
                        ? '0'
                        : '1em',
                  }"
                >
                  {{ mssgs }}
                </p>
              }
            </div>
          </div>
          <div class="confirmation-box-subitem">
            @if (message.detail.errorMessage?.length > 0) {
              <span
                class="pi pi-times-circle"
                style="color: #ef4444; padding-top: 2px; margin-top: 1em"
              ></span>
            }
            <div>
              @for (mssgs of message.detail?.errorMessage; track $index) {
                <p
                  style="margin: 1px; color: #ef4444"
                  [ngStyle]="{
                    'margin-bottom':
                      $index === message.detail.successMessage.length - 1
                        ? '0'
                        : '1em',
                    'margin-top': $index === 0 ? '1em' : '0',
                  }"
                >
                  {{ mssgs }}
                </p>
              }
            </div>
          </div>
        } @else {
          @if (message.showAsHTML) {
            <p [innerHTML]="message.detail"></p>
          } @else {
            <p
              style="margin-bottom: unset"
              [ngStyle]="
                message.severity === 'info' ? { color: '#0a1a29' } : {}
              "
            >
              {{ message.detail }}
            </p>
          }
        }

        @if (_autoCloseInfo?.message && timeRemaining) {
          {{ _autoCloseInfo?.message }}: {{ timeRemaining | timeFormat }}
        }
      </div>
      <div class="form-button">
        <app-shared-button
          [label]="labelInfo?.confirm ?? 'Ok'"
          [rounded]="true"
          [minWidth]="'10%'"
          (onClick)="confirmationHandler(message.summary, message.detail)"
        />
        @if (!message.detail?.successMessage && !message.hideCancel) {
          <app-shared-button
            [label]="labelInfo?.reject ?? 'Cancel'"
            [rounded]="true"
            [minWidth]="'10%'"
            (onClick)="rejectionHandler(message.summary)"
          />
        }
      </div>
    </div>
  </ng-template>
</p-toast>
